import { Controller } from "@hotwired/stimulus"

// When the checkout modal is dismissed (X / Esc / backdrop), leave the modal route
// by navigating — matching Figma overlay behavior over the paywall.
export default class extends Controller {
  static values = {
    dismissUrl: String,
  }

  connect() {
    this.dismissing = false
    this.ready = false
    this.container = this.element.querySelector("[data-railsui-modal-target='container']")
    if (!this.container) return

    this.wasOpen = !this.container.classList.contains("hidden")
    this.observer = new MutationObserver(() => this.handleContainerChange())
    this.observer.observe(this.container, { attributes: true, attributeFilter: ["class", "aria-hidden"] })

    // Ignore init/animation class toggles that look like a close on first paint.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.wasOpen = !this.container.classList.contains("hidden")
        this.ready = true
      })
    })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  dismiss(event) {
    event?.preventDefault()
    event?.stopPropagation()
    this.leaveCheckout()
  }

  handleContainerChange() {
    const isOpen = !this.container.classList.contains("hidden")
    if (!this.ready) {
      this.wasOpen = isOpen
      return
    }

    if (this.wasOpen && !isOpen) {
      this.leaveCheckout()
    }
    this.wasOpen = isOpen
  }

  leaveCheckout() {
    if (this.dismissing) return
    this.dismissing = true

    if (this.dismissUrlValue) {
      window.location.href = this.dismissUrlValue
    }
  }
}
